import React, {PropTypes} from 'react';
import {formatCurrency} from 'shared/util/formatCurrency';
Number.prototype.formatCurrency = formatCurrency;

const CartFooter = ({
  visible,
  total,
  countInCart,
  onReviewClick
}) => (
  <div>
    {
      visible
      ? <div className="flex space-between vertical-center animated fadeIn">
          <h4 className="flex-2">{`Total: $`}{total.formatCurrency(2)}</h4>
          <button
            disabled={!total && countInCart == 0}
            type="button"
            className="btn btn-primary btn-lg"
            onClick={onReviewClick}
          ><i className="fa fa-shopping-cart" /> {!total && countInCart == 0 ? 'Cart Empty' : 'Review Selection'}</button>
        </div>
      : null
    }
  </div>
);

CartFooter.propTypes = {
  visible: PropTypes.bool,
  total: PropTypes.number,
  countInCart: PropTypes.number,
  onReviewClick: PropTypes.func
};

CartFooter.defaultProps = {
  visible: false,
  total: 0,
  countInCart: 0
};

export default CartFooter;



// WEBPACK FOOTER //
// ./src/features/shared/CartFooter.jsx